import React from "react";
import { LessonCard } from "./LessonCard";
import type { CourseNodeWithStatus } from "@/types/courses";

interface LearningPathFeedProps {
  nodes: CourseNodeWithStatus[];
  courseName: string;
  onNodeAction: (nodeId: string) => void;
}

export const LearningPathFeed: React.FC<LearningPathFeedProps> = ({
  nodes,
  courseName,
  onNodeAction,
}) => {
  return (
    <div className="space-y-3">
      {nodes.map((node) => (
        <LessonCard
          key={node.id}
          node={node}
          courseName={courseName}
          onAction={onNodeAction}
        />
      ))}
    </div>
  );
};
